import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';

@Component({
  imports: [],
  styles: [],
  template: `
    {{ params.displayName }}
    <span class="ml-1 text-aux-error">*</span>
  `,
})
export class AgRequiredHeaderComponent implements IHeaderAngularComp {
  params!: IHeaderParams;

  agInit(params: IHeaderParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}
